import { sendTypedMessage } from './iframeUtil'

export default function openHelpPage(id) {
  sendTypedMessage('showHelpPage', id)
}
